module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_8004.826b6be3.png";